import * as React from 'react'
import {PageSection, Title} from '@patternfly/react-core'
import GenericBreadCrumb from 'src/frontend/app/components/GenericBreadCrumb'
import GenericCard from '../../components/GenericCard'
import GenericButton from '../../components/GenericButton'
import {
    PATH_TO_BO_ANAG_CAMBIO_SEZIONE_RICHIESTA,
    PATH_TO_BO_ANAG_CAMBIO_SEZIONE_RIFIUTA
} from 'src/app/utils/RoutesConstants'
import {convertUrlParamsToObject} from 'src/utilities/utility'
import GenericAlert from 'src/frontend/app/components/GenericAlert'
import {FormRifiutaCambioSezione} from './formCambioSezione/FormRifiutaCambioSezione'

class RifiutaCambioSezione extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            typeMessage: "default",
            idCambioSezione: undefined,
            idIscrizione: undefined,
        };
    }

    componentDidMount() {
        //recupero gli eventuali parametri dall'url
        var url = window.location.search?.split("?")[1]
        var urlParams = convertUrlParamsToObject(url)

        //recupero l'idIscrizione dall'url
        var idCambioSezione = urlParams?.idCambioSezione
        var idIscrizione = urlParams?.idIscrizione

        this.setState({ idCambioSezione: idCambioSezione, idIscrizione: idIscrizione })
    }


    goToCambioSezione = (redirectLink: any) => {
        this.props.history.push({
            pathname: redirectLink,
        });
    }

    submitMessageResult = (alert: any) => {
        const element = document.getElementById("pageSectionId");
        if (element)
            element.scrollIntoView({ behavior: 'smooth' });
        this.setState({ message: alert.messaggio, typeMessage: alert.type })
        if (alert.type === 'success') {
            setTimeout(async () => {
                this.goToCambioSezione(PATH_TO_BO_ANAG_CAMBIO_SEZIONE_RICHIESTA)
            }, 1000);
        }
    }

    render() {
        return (
            <>
                <PageSection id='pageSectionId'>
                    <div className='container register-container'>
                        <GenericBreadCrumb paths={[{ label: "Anagrafica", link: "#" }, { label: "Lista richieste di cambio sezione", link: PATH_TO_BO_ANAG_CAMBIO_SEZIONE_RICHIESTA }, { label: "Rifiuta", link: PATH_TO_BO_ANAG_CAMBIO_SEZIONE_RIFIUTA }]} /><br></br>
                        <Title headingLevel="h1" size="4xl">Rifiuta richiesta cambio sezione</Title><br></br>
                        <GenericAlert hidden={this.state.message === ''} label={this.state.message} color={this.state.typeMessage}></GenericAlert>
                        <GenericCard isExpandibleCard={false} header={'Compila i seguenti campi'} body={<FormRifiutaCambioSezione messaggio={this.submitMessageResult} idIscrizione={this.state.idIscrizione} idCambioSezione={this.state.idCambioSezione} />} />
                        <div className='row'>
                            <div className='col-1'>
                                <GenericButton label={"INDIETRO"} color={"secondary"} onClick={() => this.goToCambioSezione(PATH_TO_BO_ANAG_CAMBIO_SEZIONE_RICHIESTA)} />
                            </div>
                            <div className='col-1'>
                                <GenericButton label={"CONFERMA"} color={"primary"} type={'submit'} form='rifiuta' isDisabled={this.state.typeMessage === 'success'} />
                            </div>
                        </div>
                    </div >
                </PageSection>
                <br />
                <PageSection>
                    <div className='container register-container'>
                        <Title headingLevel='h3'>Legenda</Title>
                        <p>* Campo obbligatorio</p>
                    </div>
                </PageSection>
            </>
        );
    }
};

export default RifiutaCambioSezione;
